import { fontSize as fontSize_1 } from './fontSize.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import FontSizePicker from '../FontSizePicker';
import { RibbonButton, RibbonDropDownProps } from './RibbonButton';

import { setFontSize } from 'roosterjs-editor-api';

const fontSize: RibbonButton = {
    key: 'fontSize',
    title: () => loc(fontSize_1),
    imageSrc: require('../svg/fontsize.svg'),
    createDropDownCallback: React.memo(
        ({ target, plugin, dismiss, logUsage }: RibbonDropDownProps) => {
            const onSelectSize = React.useCallback(
                fontSize => {
                    setFontSize(plugin.getEditor(), fontSize + 'pt');
                    logUsage('setFontSize', fontSize + 'pt');
                },
                [plugin]
            );
            return (
                <FontSizePicker
                    menuTargetElement={target}
                    onDismissMenu={dismiss}
                    onSelectSize={onSelectSize}
                    selectedSize={plugin.getFormatState().fontSize}
                />
            );
        }
    ),
};

export default fontSize;
